import { PaginatorDesignTokens } from '@primeuix/themes/types/paginator';

export const paginatorPreset: PaginatorDesignTokens = {
   root: {
     gap: '0',
   }
}
